import TypeToReducer from 'type-to-reducer';
import set from 'lodash/set';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_CUSTOM_FIELDS_EMPLOYEE_FORM,
  GET_CUSTOM_FIELDS_EMPLOYEE_BY_ID,
  MODIFY_EDITING_CUSTOM_FIELDS_EMPLOYEE,
  ADD_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE,
  REMOVE_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE,
} from '../constants';

const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: { type: 'Numerico', elements: [] },
};

const resetForm = (state) => ({ ...initialState });

const getByIdPending = (state) => ({ ...state, isFetching: true });

const getByIdRejected = (state) => ({ ...state, isFetching: false });

const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.project },
});

const modifyEmployee = (state, { payload }) => ({
  ...state,
  editing: {
    ...Object.keys(payload).reduce(
      // Necesario para que funcionen los campos personalizados la edicion.
      (re, k) => {
        set(re, k, payload[k]);
        return re;
      },
      { ...state.editing }
    ),
  },
});

const modifyEmployee2 = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    ...payload,
  },
});

const addCustomField = (state) => ({
  ...state,
  editing: {
    ...state.editing,
    elements: [...state.editing.elements, { key: '', value: '' }],
  },
});

const removeCustomField = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    elements: state.editing.elements
      .map((c, i) => (i === payload ? { ...c, deleted: true } : { ...c }))
      .filter((c, i) => c._id || i !== payload),
  },
});

const reducers = {
  [RESET_CUSTOM_FIELDS_EMPLOYEE_FORM]: resetForm,
  [GET_CUSTOM_FIELDS_EMPLOYEE_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [MODIFY_EDITING_CUSTOM_FIELDS_EMPLOYEE]: modifyEmployee,
  [ADD_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE]: addCustomField,
  [REMOVE_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE]: removeCustomField,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/reducers/employees_form_reducers.js